const sampleText = {
    version: '2.0',
    template: {
        outputs: [
            {
                simpleText: {
                    text:
                        '텍스트형 답변입니다.\n\n텍스트형 답변은 최대 1000자까지 가능하며, 500자가 넘어가면 이후의 글자는 생략되고 전체 보기 버튼을 통해서 전체 내용을 확인할 수 있습니다.'
                }
            },
            {
                simpleImage: {
                    imageUrl:
                        'https://file3.cloudturing.com/upload/sample/aa0a3cbc7e8599041585127125996.jpg',
                    altText: 'sample600'
                }
            }
        ],
        quickReplies: [
            {
                action: 'message',
                label: '뒤로가기',
                messageText: '발화를 입력해주세요.'
            },
            {
                action: 'message',
                label: '처음으로',
                messageText: '발화를 입력해주세요.'
            }
        ]
    }
};

const sampleCarousel = {
    version: '2.0',
    template: {
        outputs: [
            {
                simpleText: {
                    text: '아래는 케로셀 카드 답변입니다. '
                }
            },
            {
                carousel: {
                    type: 'basicCard',
                    items: [
                        {
                            title: '첫 번째 카드 제목입니다. ',
                            description: '첫 번째 카드 설명입니다. ',
                            thumbnail: {
                                imageUrl:
                                    'https://file3.cloudturing.com/upload/sample/3e7e56ec4d8b4a021585127125955.jpg'
                            },
                            buttons: [
                                {
                                    label: '버튼 1입니다.',
                                    action: 'message',
                                    messageText: '발화를 입력해주세요.'
                                },
                                {
                                    label: '버튼 2입니다.',
                                    action: 'message',
                                    messageText: '발화를 입력해주세요.'
                                },
                                {
                                    label: '버튼 3입니다.',
                                    action: 'message',
                                    messageText: '발화를 입력해주세요.'
                                }
                            ]
                        },
                        {
                            title: '두 번째 카드 제목입니다. ',
                            description: '두 번째 카드 설명입니다.',
                            thumbnail: {
                                imageUrl:
                                    'https://file3.cloudturing.com/upload/sample/3e7e56ec4d8b4a021585127125955.jpg'
                            },
                            buttons: [
                                {
                                    label: '버튼 1입니다.',
                                    action: 'message',
                                    messageText: '발화를 입력해주세요.'
                                },
                                {
                                    label: '버튼 2입니다.',
                                    action: 'message',
                                    messageText: '발화를 입력해주세요.'
                                },
                                {
                                    label: '버튼 3입니다.',
                                    action: 'message',
                                    messageText: '발화를 입력해주세요.'
                                }
                            ]
                        }
                    ]
                }
            }
        ],
        quickReplies: [
            {
                action: 'message',
                label: '뒤로가기',
                messageText: '발화를 입력해주세요.'
            },
            {
                action: 'message',
                label: '처음으로',
                messageText: '발화를 입력해주세요.'
            }
        ]
    }
};

export { sampleText, sampleCarousel };
